import cn from 'classnames';
import LowQualityWarning from "./LowQualityWarning";
import ManualHighQualityWarning from "./ManualHighQualityWarning";
import { jsx as _jsx } from "react/jsx-runtime";
var BannerWarning = function BannerWarning(_ref) {
  var isXxs = _ref.isXxs,
    currentQualityWarning = _ref.currentQualityWarning;
  return /*#__PURE__*/_jsx("div", {
    "data-testid": "banner-quality-warning",
    className: cn('absolute min-h-48 top-0 left-0 bg-base-main-80 z-5', isXxs ? 'rounded-br-5 px-8' : 'w-full px-16', currentQualityWarning ? 'cui-is-visible' : 'cui-is-hidden'),
    children: currentQualityWarning && (currentQualityWarning === 'low-quality' ? /*#__PURE__*/_jsx(LowQualityWarning, {
      isXxs: isXxs
    }) : /*#__PURE__*/_jsx(ManualHighQualityWarning, {
      isXxs: isXxs
    }))
  });
};
export default BannerWarning;